import React from 'react'
import { withTranslation } from 'react-i18next'
import qs from 'qs'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Redirect } from 'react-router-dom'

import { AUTH__LOGIN_REFRESH } from '../store/actions'

import { checkIsDefined } from '../utils/common'

class oauthLogin extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {
            isReady: false,
            isReg: false,
            provider: null,
            authenticationRedirect: {
                path: '/account/my-projects',
                query: {},
                state: {},
            },
            registrationRedirect: {
                path: '/oauth2/successful-registration',
                query: {},
                state: {},
            },
            errorRedirect: {
                path: '/auth',
                query: {},
                state: {},
            },
        }
        this.base_state = this.state
    }

    async componentDidMount() {
        this._isMounted = true

        try {
            const { isAuth } = this.props

            if (!isAuth) {
                const queryParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
                console.log('Query params:', queryParams)

                const provider = queryParams.provider ? queryParams.provider : null
                const isReg = queryParams.is_reg && queryParams.is_reg === 'true'
                await this.setState({
                    isReg,
                    provider,
                })

                if (queryParams.error) {
                    const errorCode = queryParams.errorCode ? parseInt(queryParams.errorCode) : null
                    const handleError = this.errorHandler(errorCode, queryParams.error.toString())

                    await this.setState(prevState => ({
                        errorRedirect: {
                            ...prevState.errorRedirect,
                            query: {
                                action: isReg ? 'registration' : 'authentication',
                            },
                            state: {
                                toast: handleError.showToast ? handleError.toast : null,
                            },
                        },
                    }))
                } else {
                    // Required params
                    const isDefined = checkIsDefined([
                        queryParams.access_token,
                        queryParams.token_type,
                        queryParams.refresh_token,
                        queryParams.expires_in,
                        queryParams.scope,
                        queryParams.id,
                        queryParams.login,
                        queryParams.authorities,
                    ])

                    if (isDefined) {
                        const { P__AUTH__LOGIN_REFRESH } = this.props
                        await P__AUTH__LOGIN_REFRESH({
                            user: {
                                authorities: queryParams.authorities,
                                id: queryParams.id,
                                login: queryParams.login,
                            },
                            scope: queryParams.scope,
                            token_type: queryParams.token_type,
                            access_token: queryParams.access_token,
                            expires_in: queryParams.expires_in,
                            refresh_token: queryParams.refresh_token,
                        })

                        if (isReg) {
                            await this.setState(prevState => ({
                                registrationRedirect: {
                                    ...prevState.registrationRedirect,
                                    path:
                                        typeof queryParams.success_redirect === 'undefined'
                                            ? prevState.registrationRedirect.path
                                            : queryParams.success_redirect,
                                    state: {
                                        provider,
                                    },
                                },
                            }))
                        } else {
                            await this.setState(prevState => ({
                                authenticationRedirect: {
                                    ...prevState.authenticationRedirect,
                                    path:
                                        typeof queryParams.success_redirect === 'undefined'
                                            ? prevState.authenticationRedirect.path
                                            : queryParams.success_redirect,
                                    state: {
                                        provider,
                                    },
                                },
                            }))
                        }

                        // Временный хак (пока нет страницы поздравления после "регистрации")
                        if (isReg) {
                            await this.setState(prevState => ({
                                authenticationRedirect: {
                                    ...prevState.authenticationRedirect,
                                    query: {
                                        isReg: 'true',
                                    },
                                },
                            }))
                        }
                    } else {
                        const handleError = this.errorHandler('_1', '')

                        await this.setState(prevState => ({
                            errorRedirect: {
                                ...prevState.errorRedirect,
                                query: {
                                    action: isReg ? 'registration' : 'authentication',
                                },
                                state: {
                                    provider,
                                    toast: handleError.showToast ? handleError.toast : null,
                                },
                            },
                        }))
                    }
                }
            }
        } catch (err) {
            console.error(err)

            const handleError = this.errorHandler('_2', '')

            const { isReg } = this.state
            await this.setState(prevState => ({
                errorRedirect: {
                    ...prevState.errorRedirect,
                    query: {
                        action: isReg ? 'registration' : 'authentication',
                    },
                    state: {
                        toast: handleError.showToast ? handleError.toast : null,
                    },
                },
            }))
        } finally {
            await this.setState({
                isReady: true,
            })
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    errorHandler = (code = null, message = '') => {
        const { t } = this.props

        let result = {
            showToast: true,
            toast: {
                type: 'error',
                title: t('Authorization error'),
                message: t('Something went wrong. Please try again later'),
                time: 6000,
            },
        }

        if (code !== null) {
            switch (code) {
                // Internal errors
                case '_1':
                    // Undefined required field(s)
                    break
                case '_2':
                    // Code exec exception
                    break
                // External errors
                case 11:
                    result.toast.message = t('Such an account already exists')
                    break
                case 21:
                    result.toast.message = t('The user is blocked')
                    break
                case 25:
                    // provider errors
                    const textCode = message.substring(message.indexOf('[') + 1, message.indexOf(']'))
                    if (textCode.length > 1) {
                        switch (textCode) {
                            case 'access_denied':
                                result.showToast = false
                                break
                            case 'missing_user_info_uri':
                                break
                            case 'missing_user_name_attribute':
                                break
                            case 'invalid_user_info_response':
                                break
                            default:
                                break
                        }
                    }
                    break
                case 26:
                    result.toast.message = t('Failed to get email address')
                    break
                case 27:
                    result.toast.message = t('This authorization method is temporarily unavailable')
                    break
                case 28:
                    result.toast.message = t('Such an account already exists')
                    break
                case 29:
                    break
                case 30:
                    break
                default:
                    break
            }
        }

        return result
    }

    render() {
        const { isReady, isReg, authenticationRedirect, registrationRedirect, errorRedirect } = this.state
        const { isAuth } = this.props

        return isReady ? (
            isAuth ? (
                <Redirect
                    to={{
                        pathname: authenticationRedirect.path,
                        search: `?${new URLSearchParams(authenticationRedirect.query).toString()}`,
                        state: authenticationRedirect.state,
                    }}
                />
            ) : (
                // isReg ? (
                //     <Redirect
                //         to={{
                //             pathname: registrationRedirect.path,
                //             state: registrationRedirect.state,
                //         }}
                //     />
                // ) : (
                //     <Redirect
                //         to={{
                //             pathname: authenticationRedirect.path,
                //             state: authenticationRedirect.state,
                //         }}
                //     />
                // )
                <Redirect
                    to={{
                        pathname: errorRedirect.path,
                        search: `?${new URLSearchParams(errorRedirect.query).toString()}`,
                        state: errorRedirect.state,
                    }}
                />
            )
        ) : null
    }
}

const mapStateToProps = state => {
    return {
        isAuth: state.is_auth,
    }
}
const mapDispatchToProps = dispatch => ({
    P__AUTH__LOGIN_REFRESH: obj => dispatch(AUTH__LOGIN_REFRESH(obj)),
})

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation('translations'))(oauthLogin)
